import { Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";

import AppButton from "../../../commons/buttons/AppButton";
import AppContainer from "../../../commons/containers/AppContainer";
import AppInput from "../../../commons/inputs/AppInput";
import AppLinkButton from "../../../commons/buttons/AppLinkButton";
import AppLoading from "../../../commons/AppLoading";
import HallAppToast from "../../../commons/HallAppToast";
import HallPointsAPI from "../HallPointsAPI";

const hallPointsAPI = new HallPointsAPI();

function ModalHallPointRewardsConfig({ closeShow, show, service, call }) {

    const [selectedDays, setSelectedDays] = useState([]);
    const [qtdPoints, setQtdPoints] = useState(0);
    const [isLoading, setIsLoading] = useState(false)

    const weekDays = [
        { label: 'Domingo', value: 'SUNDAY' },
        { label: 'Segunda', value: 'MONDAY' },
        { label: 'Terça', value: 'TUESDAY' },
        { label: 'Quarta', value: 'WEDNESDAY' },
        { label: 'Quinta', value: 'THURSDAY' },
        { label: 'Sexta', value: 'FRIDAY' },
        { label: 'Sábado', value: 'SATURDAY' },
    ];

    useEffect(() => {
        setQtdPoints(service?.qtdPoints || 0);

        if (service.weekDays) {
            const daysFromConfig = service.weekDays;
            setSelectedDays(daysFromConfig);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const toggleDay = (day) => {
        if (selectedDays.includes(day)) {
            setSelectedDays(selectedDays.filter(d => d !== day));
        } else {
            setSelectedDays([...selectedDays, day]);
        }
    };

    const save = async () => {

        if (qtdPoints === 0 || selectedDays.length === 0) {
            HallAppToast.error('Preencha os campos abaixo.')
            return;
        }

        const data = {
            qtdPoints: qtdPoints,
            weekDays: selectedDays,
            serviceId: service?.serviceId
        }

        try {
            setIsLoading(true)
            await hallPointsAPI.createRewards(data)
            HallAppToast.success();
            setIsLoading(false)
            if (call) {
                call()
            }
        } catch (_) {
            HallAppToast.error();
            setIsLoading(false)
        }
    };



    return (
        <>
            <Modal show={show} fullscreen={true} onHide={() => closeShow()}>
                <Modal.Header className='custom-close-button' closeButton>
                    <Modal.Title style={{ textAlign: 'center', fontSize: '15px' }}>
                        HALLPOINTS - CONFIGURAR SERVIÇO
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AppContainer>
                        <h1>Serviço: {service?.serviceName}</h1>

                        <Form>
                            <label>Informe a quantidade de pontos para resgate?</label>
                            <AppInput
                                label="Quantidade de pontos"
                                name="points"
                                type='number'
                                value={qtdPoints}
                                errors={[]}
                                onChange={(e) => { setQtdPoints(e.target.value) }} />
                        </Form>
                        <div className="mb-4">
                            <h5 className="mb-3">Disponibilidade para uso dos pontos</h5>
                            {weekDays.map((day) => (
                                <div className="form-check" key={day.value}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`day-${day.value}`}
                                        checked={selectedDays.includes(day.value)}
                                        onChange={() => toggleDay(day.value)}
                                    />
                                    <label className="form-check-label" htmlFor={`day-${day.value}`}>
                                        {day.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <hr></hr>

                        {
                            isLoading ? <AppLoading /> : <>
                                <AppButton fullWidth={true} name="salvar" width="100%" onClick={save} />

                                <div style={{ marginTop: '20px' }}>
                                    <AppLinkButton fullWidth={true} name="voltar" onClick={closeShow} width="100%" />
                                </div>
                            </>
                        }

                    </AppContainer>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ModalHallPointRewardsConfig;